import React, { FunctionComponent } from "react";
import { Trans } from "@lingui/macro";
import { PersonalTaxFormTitle } from "../PersonalTaxFormTitle";
import { Disclaimer } from "./Disclaimer";
import { useHelpDialogContext } from "components/header/help/HelpDialogProvider";
import NumberFormat from "react-number-format";
import { useAangifte } from "components/aangifte/AangifteProvider";
import { PostcodeField } from "./PostcodeField";
import { useTranslate } from "../hooks/useTranslate";
import { Rubriek } from "components/aangifte/Rubriek";
import { NumberInput } from "components/inputs/NumberInput";

export interface Props {}

export const PersonaliaForm: FunctionComponent<Props> = () => {
  const { openDialog } = useHelpDialogContext();
  const {
    aangifte: { city },
  } = useAangifte();

  const translate = useTranslate();

  return (
    <div className="main">
      <div id="tab_information">
        <PersonalTaxFormTitle icon="info">
          <Trans>Personalia</Trans>
        </PersonalTaxFormTitle>
        <div className="velden">
          <div className="veld lang">
            <label htmlFor="postalcode">
              <Trans>Postcode</Trans>
            </label>
            <PostcodeField />
          </div>

          <div className="veld lang">
            <label htmlFor="town">
              <Trans>Gemeente</Trans>
            </label>
            <input type="text" name="town" id="town" disabled value={city ? translate(city.name) : ""} />
          </div>

          <div className="veld kort">
            <label htmlFor="trate">
              <Trans>Gemeentebelasting</Trans>
            </label>
            <NumberFormat
              id="trate"
              name="trate"
              decimalScale={2}
              fixedDecimalScale
              disabled
              value={city ? city.taxRate / 100 : ""}
            />
            &nbsp;%
          </div>
        </div>
        <div className="velden">
          <div className="titel">
            <h2>
              <Trans>Gemiddelde aanslagvoet vorig jaar</Trans>&nbsp;
              <button
                className="avehelp"
                type="button"
                onClick={() => openDialog({ defaultSelectedCategoryIndex: 1, defaultSelectedItemInCategoryIndex: 4 })}
              >
                [?]
              </button>
            </h2>
          </div>

          <div className="veld kort">
            <label htmlFor="3006">
              <Trans>De aangever</Trans>
            </label>
            <Rubriek code="3006">
              {({ rubriek, updateValue }) => (
                <NumberInput
                  id="3006"
                  name="3006"
                  className="percentage"
                  value={(rubriek.value as number)}
                  onValueChange={({ floatValue }) => updateValue(floatValue)}
                />
              )}
            </Rubriek>
            &nbsp;%
          </div>

          <div className="veld kort">
            <label htmlFor="3007">
              <Trans>De partner</Trans>
            </label>
            <Rubriek code="3007">
              {({ rubriek, updateValue }) => (
                <NumberInput
                  id="3007"
                  name="3007"
                  className="percentage"
                  value={(rubriek.value as number)}
                  onValueChange={({ floatValue }) => updateValue(floatValue)}
                />
              )}
            </Rubriek>
            &nbsp;%
          </div>
        </div>
        <Disclaimer />
      </div>
    </div>
  );
};

PersonaliaForm.displayName = "PersonaliaForm";
